export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.functionServices': '功能服务',
  'menu.solution': '解决方案',
  'menu.smartHardware': '智能硬件',
  'menu.downLoadApp': 'App下载',

  'menu.functionServices.onlineFiles': '在线文件管理',
  'menu.functionServices.meterReading': '抄表录入',
  'menu.functionServices.expressDelivery': '快递管理',
  'menu.functionServices.onlineRepair': '在线报修',
  'menu.functionServices.waterElectricityCoalReporting': '水电煤上报',
  'menu.functionServices.complaint': '投诉建议',
  'menu.functionServices.inspectionCode': '智慧巡检码',
  'menu.functionServices.visitorRegistration': '访客登记',
  'menu.functionServices.material': '物料管理',
  'menu.functionServices.accessCard': '出入证管理',
  'menu.functionServices.mobileMeterReading': '移动抄表',

  'menu.functionServices.customerService': '客服IM',
  'menu.functionServices.ownerVoting': '业主投票',
  'menu.functionServices.smsBroadcast': '短信群发',

  'menu.functionServices.depositManagement': '押金管理',
  'menu.functionServices.eInvoice': '电子发票',
  'menu.functionServices.onlinePayment': '在线缴费',

  'menu.functionServices.streetOrCommunities': '智慧街道社区',

  'menu.solution.company': '物业公司',
  'menu.solution.streetOrCommunities': '街道/社区',
  'menu.solution.communities': '社区O2O',
  'menu.solution.developer': '地产开发商',

  'menu.smartHardware.bluedoor': '蓝牙门禁',
  'menu.smartHardware.facedoor': '人脸识别门禁',
  'menu.smartHardware.facecamera': '人脸识别摄像机',
  'menu.smartHardware.parcellocker': '智能快递柜',
  'menu.smartHardware.chargingpile': '智能充电桩',
  'menu.smartHardware.parking': '智慧停车',

  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
